import { render } from "./PreviewTab.vue?vue&type=template&id=30ff4f34&scoped=true"
import script from "./PreviewTab.vue?vue&type=script&lang=js"
export * from "./PreviewTab.vue?vue&type=script&lang=js"

import "./PreviewTab.vue?vue&type=style&index=0&id=30ff4f34&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ff4f34"]])

export default __exports__